// extracted by mini-css-extract-plugin
export default {"wrapper":"fH1wTwlNDV","dark":"LhGB6AzTyD"};